(function () {
  function closeAll(except) {
    document.querySelectorAll('.mh-nav__item--has-dropdown').forEach(function (item) {
      if (except && item === except) return;
      item.classList.remove('mh-nav__item--open');
      var panel = item.querySelector('.mh-nav__dropdown');
      var btn = item.querySelector('.mh-nav__trigger');
      if (panel) panel.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function init() {
    document.querySelectorAll('.mh-nav__item--has-dropdown').forEach(function (item) {
      var btn = item.querySelector('.mh-nav__trigger');
      var panel = item.querySelector('.mh-nav__dropdown');
      if (!btn || !panel) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = item.classList.contains('mh-nav__item--open');
        closeAll(item);
        if (!open) {
          item.classList.add('mh-nav__item--open');
          panel.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
        } else {
          item.classList.remove('mh-nav__item--open');
          panel.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.mh-nav__item--has-dropdown')) closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
